export const APP_CONSTANTS = {
  API_TELADOC_NAME: 'api-teladoc'
};
